export const POINT_LIGHT_BRIGHTNESS = .3;
